var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2299(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299",
    transform: "translate(-319 -306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 24,
    height: 20,
    rx: 3,
    transform: "translate(319 306)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    "data-name": "Rectangle 1445",
    width: 1.5,
    height: 12,
    rx: 0.75,
    transform: "translate(324 310)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 1.5,
    height: 12,
    rx: 0.75,
    transform: "translate(333 310)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1446",
    "data-name": "Rectangle 1446",
    width: 1.5,
    height: 12,
    rx: 0.75,
    transform: "translate(328 310)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1447",
    "data-name": "Rectangle 1447",
    width: 1.5,
    height: 12,
    rx: 0.75,
    transform: "translate(337 310)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2299);
export default __webpack_public_path__ + "static/media/Group 2299.0bc02a31.svg";
export { ForwardRef as ReactComponent };